import classNames from 'classnames';
import type { ContainerWidth } from 'ui/components/4-habitats/Container/Container';
import styles from './ContentSection.module.scss';

export interface UI_ContentSectionProps {
	width: ContainerWidth;
	title: string;
	centered?: boolean;
	children?: React.ReactNode;
}

export const UI_ContentSection: React.FC<UI_ContentSectionProps> = ({ children, centered, title }) => {
	return (
		<section aria-label={title} className={classNames(styles.Section, { [styles.Section___centered]: centered })}>
			<div className={styles.Section_content}>{children}</div>
		</section>
	);
};
